"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const EmptyMessageContainer = (0, _styledBase.default)("div", {
  target: "e11npagm0",
  label: "EmptyMessageContainer"
})("height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:", props => props.isPrivate && _netlifyCmsUiDefault.colors.textFieldBorder, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhTGlicmFyeS9FbXB0eU1lc3NhZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3dDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhTGlicmFyeS9FbXB0eU1lc3NhZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNvbG9ycyB9IGZyb20gJ25ldGxpZnktY21zLXVpLWRlZmF1bHQnO1xuXG5jb25zdCBFbXB0eU1lc3NhZ2VDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgY29sb3I6ICR7cHJvcHMgPT4gcHJvcHMuaXNQcml2YXRlICYmIGNvbG9ycy50ZXh0RmllbGRCb3JkZXJ9O1xuYDtcblxuZnVuY3Rpb24gRW1wdHlNZXNzYWdlKHsgY29udGVudCwgaXNQcml2YXRlIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8RW1wdHlNZXNzYWdlQ29udGFpbmVyIGlzUHJpdmF0ZT17aXNQcml2YXRlfT5cbiAgICAgIDxoMT57Y29udGVudH08L2gxPlxuICAgIDwvRW1wdHlNZXNzYWdlQ29udGFpbmVyPlxuICApO1xufVxuXG5FbXB0eU1lc3NhZ2UucHJvcFR5cGVzID0ge1xuICBjb250ZW50OiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIGlzUHJpdmF0ZTogUHJvcFR5cGVzLmJvb2wsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBFbXB0eU1lc3NhZ2U7XG4iXX0= */"));

function EmptyMessage({
  content,
  isPrivate
}) {
  return (0, _core.jsx)(EmptyMessageContainer, {
    isPrivate: isPrivate
  }, (0, _core.jsx)("h1", null, content));
}

EmptyMessage.propTypes = {
  content: _propTypes.default.string.isRequired,
  isPrivate: _propTypes.default.bool
};
var _default = EmptyMessage;
exports.default = _default;